import React from "react";
import { RouteObject } from "react-router-dom";
import { PluginModule, NavigationItem } from "../plugins/types";
import { CrmApp } from "./App";
import { ClientsPage } from "./pages/ClientsPage";

// Routes for the CRM plugin — direct routes without nested structure
const routes: RouteObject[] = [
  {
    path: "/crm",
    element: React.createElement(ClientsPage),
  },
  {
    path: "/crm/clients",
    element: React.createElement(ClientsPage),
  },
];

// Navigation items displayed in the header
const navigation: NavigationItem[] = [
  {
    name: "Clients",
    route: "/crm",
    icon: "Users",
    order: 8,
    permissions: ["crm:read"],
  },
];

// Plugin module export
const revisrCrmPlugin: PluginModule = {
  routes,
  navigation,
  providers: [],
  config: {
    name: "Revisr CRM",
    version: "1.0.0",
    description: "Client relationship management for Revisr",
  },
  initialize: async () => {
    console.log("📇 Revisr CRM plugin initialized");
  },
  cleanup: async () => {
    console.log("📇 Revisr CRM plugin cleaned up");
  },
};

export default revisrCrmPlugin;
